import React from 'react';
import memoize from 'memoize-one';
import { Formik, Form } from 'formik';
import { StackedText, StackedSelect, InlineRadioGroup } from '@tpco/blueprint-react';
import { P3Configuration } from 'models/interfaces/P3Configurations';
import {
  nameValidation,
  entitlementValidation,
  buildTemplateOptions
} from './P3CampaignEditFormConfiguration';
// import { templateSelectionOptions } from './P3CampaignEditConfiguration';

interface P3CampaignEditFormProps {
  templateOptionId: number;
  configurationName: string;
  configurationId?: string;
  rankPoints: number;
  coverageAreas: number;
  previewAds: number;
  templates: P3Configuration[];
  // view toggles
  hasConfiguration: boolean;
  isNameEditable: boolean;
  areRankPointsEditable: boolean;
  isCampaignEditable: boolean;
  isReadOnlyConfiguration: boolean;
  // functions
  onTemplateOptionChange: ({ value }: { value: string }) => void;
  onTemplateSelected: ({ value }: { value: string }) => void;
  onRankPointsChange: ({ value }: { value: string }) => void;
  onConfigurationNameChange: ({ value }: { value: string }) => void;
  onClickRankButton: (event: any) => void;
  onClickRemoveConfig: () => void;
}

const P3CampaignEditForm: React.FC<P3CampaignEditFormProps> = ({
  templateOptionId,
  configurationName,
  configurationId,
  rankPoints,
  coverageAreas,
  previewAds,
  templates,
  hasConfiguration,
  isReadOnlyConfiguration,
  isNameEditable,
  areRankPointsEditable,
  isCampaignEditable,
  onTemplateOptionChange,
  onTemplateSelected,
  onRankPointsChange,
  onConfigurationNameChange,
  onClickRankButton,
  onClickRemoveConfig
}: P3CampaignEditFormProps) => {
  // init template selection options
  const templateSelectionOptions = [
    { value: 1, name: 'Create New', checked: true },
    { value: 2, name: 'Apply Configuration Draft' }
  ];

  // build template select options from p3 templates
  // memoize data to prevent unneccessary re-calculation (heavy cost for this data)
  const memoizedRenderData = memoize(buildTemplateOptions);
  const templateOptions = memoizedRenderData(templates);

  //   console.log('templateOptions: ', templateOptions);

  const canEditTemplate = hasConfiguration && isCampaignEditable && !isReadOnlyConfiguration;
  const readOnlyCampaign = isReadOnlyConfiguration;
  //  templateOptionId = templateOptionId ? templateOptionId: 1;
  console.log(`templateOptionId`, templateOptionId);

  return (
    <Formik
      initialValues={{
        templateOptionId,
        configurationName,
        configurationId,
        rankPoints,
        coverageAreas,
        previewAds
      }}
      onSubmit={values => console.log('Submitting P3CampaignEdit: ', values)}
      enableReinitialize={true}
    >
      {({ isValid, isSubmitting, values, touched, errors, submitForm }) => (
        <Form className="card edit-campaign__container">
          <h4 className="edit-campaign__title">Points Configuration</h4>
          {!hasConfiguration ? (
            <React.Fragment>
              <InlineRadioGroup
                htmlId="edit-campaign-template"
                fieldName="templateOptionId"
                labelText="Template Configuration"
                onChange={onTemplateOptionChange}
                options={templateSelectionOptions}
                touched={touched}
                errors={errors}
                className={
                  ' saturn-form-group saturn-col saturn-flex-column inline-max-radio-config-draft'
                }
              />
              {templateOptionId === 2 || templateOptionId === 3 ? (
                <StackedSelect
                  htmlId="edit-campaign-template"
                  fieldName="configurationId"
                  labelText="Templates"
                  disabled={hasConfiguration}
                  onChange={onTemplateSelected}
                  optionGroups={templateOptions}
                  className={' saturn-form-group saturn-col saturn-flex-column'}
                />
              ) : null}
            </React.Fragment>
          ) : null}

          <StackedText
            className="form-group__col-flex-column saturn-form-group saturn-col saturn-flex-column"
            htmlId="edit-p3-name"
            fieldName="configurationName"
            labelText="Configuration Name"
            disabled={!isNameEditable}
            onChange={onConfigurationNameChange}
            validate={nameValidation}
          />
          <StackedText
            className="form-group__col-flex-column saturn-form-group saturn-col saturn-flex-column"
            htmlId="edit-p3-name"
            fieldName="rankPoints"
            labelText="Points"
            type={'number'}
            disabled={!areRankPointsEditable}
            onChange={onRankPointsChange}
            validate={entitlementValidation}
          />
          {canEditTemplate ? (
            <div className="p3-edit__action-container">
              <button
                type="button"
                className="btn btn-primary p3-edit__action"
                onClick={onClickRankButton}
              >
                Edit Configuration
              </button>
              <button
                type="button"
                className="btn btn-danger p3-edit__action"
                onClick={onClickRemoveConfig}
              >
                Remove Configuration
              </button>
            </div>
          ) : null}
          {readOnlyCampaign ? (
            <div className="p3-edit__action-container">
              <button
                type="button"
                className="btn btn-primary p3-edit__action"
                onClick={onClickRankButton}
              >
                View Configuration
              </button>
            </div>
          ) : null}
        </Form>
      )}
    </Formik>
  );
};

export default P3CampaignEditForm;
